/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ApiKeyCreate interface.
 */
export function instanceOfApiKeyCreate(value) {
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('authorizedPermissions' in value) || value['authorizedPermissions'] === undefined)
        return false;
    return true;
}
export function ApiKeyCreateFromJSON(json) {
    return ApiKeyCreateFromJSONTyped(json, false);
}
export function ApiKeyCreateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'label': json['label'],
        'authorizedPermissions': json['authorized_permissions'],
        'autoGenerated': json['auto_generated'] == null ? undefined : json['auto_generated'],
    };
}
export function ApiKeyCreateToJSON(json) {
    return ApiKeyCreateToJSONTyped(json, false);
}
export function ApiKeyCreateToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'label': value['label'],
        'authorized_permissions': value['authorizedPermissions'],
        'auto_generated': value['autoGenerated'],
    };
}
